if(document.querySelector('.sticky_atc_main')){
   var stickyAtcHeight = document.querySelector('.sticky_atc_main').getBoundingClientRect().height;
   // On mobile/tablet the bar sits 64px above the bottom nav, so add that offset
   var bottomNavOffset = window.innerWidth <= 989 ? 64 : 0;
   document.body.style.setProperty('--sticky-atc-height', (stickyAtcHeight + bottomNavOffset) + 'px');
}

document.querySelectorAll('.sticky_atc_main .custom_dropdown').forEach((dropdown) => {
    dropdown.addEventListener("click",function(){
        dropdown.classList.toggle("active");
    });
});

document.querySelectorAll('.sticky_atc_main .custom_dropdown .dropdown_options .js_change').forEach((dropdownItem) => {
    dropdownItem.addEventListener("click",function(e){
        e.stopPropagation();
        var variantText = dropdownItem.innerText,
            variant_id = parseInt(dropdownItem.getAttribute("variant_id"));
        dropdownItem.closest(".custom_dropdown").querySelector(".dropdown_selected .selected_variant").innerText = variantText;

        dropdownItem.closest(".custom_dropdown").classList.remove("active");

        if(!document.querySelector(`variant-selects fieldset input[value="${variantText}"]:checked`)){
            document.querySelector(`variant-selects fieldset input[value="${variantText}"]`).click();
        }
    });
});

subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
  var variant = event.data.variant;

  if(document.querySelector(".sticky_atc_main .custom_dropdown .selected_variant")){
    document.querySelector(".sticky_atc_main .custom_dropdown .selected_variant").innerText = variant.title;


    document.querySelectorAll(".sticky_atc_main .sell_price").forEach((singleElem) => {
        singleElem.innerHTML = `${Shopify.formatMoney(variant.price, document.body.getAttribute('money_format'))}`;
    });

    document.querySelectorAll(".sticky_atc_main .comp_price").forEach((singleElem) => {
        if(variant.compare_at_price > variant.price){
            singleElem.innerHTML = `${Shopify.formatMoney(variant.compare_at_price, document.body.getAttribute('money_format'))}`;
            singleElem.classList.remove("hidden");
        }else{
            singleElem.classList.add("hidden");
        }
    });

    if(variant.available){
        if(document.querySelector(".sticky_atc_main .atc_button_js span")){
            document.querySelector(".sticky_atc_main .atc_button_js span").innerHTML =  window.variantStrings.addToCart;
        }
        if(document.querySelector(".sticky_atc_main .atc_button_js")){
            document.querySelector(".sticky_atc_main .atc_button_js").classList.remove("pointerEventsNone");
        }
        if(document.querySelector(".sticky_atc_main .checkout_JS")){
            document.querySelector(".sticky_atc_main .checkout_JS").classList.remove("pointerEventsNone");
        }
    }else{
        if(document.querySelector(".sticky_atc_main .atc_button_js span")){
           document.querySelector(".sticky_atc_main .atc_button_js span").innerHTML =  window.variantStrings.soldOut;
        }
        if(document.querySelector(".sticky_atc_main .atc_button_js")){
            document.querySelector(".sticky_atc_main .atc_button_js").classList.add("pointerEventsNone");
        }
        if(document.querySelector(".sticky_atc_main .checkout_JS")){
            document.querySelector(".sticky_atc_main .checkout_JS").classList.add("pointerEventsNone");
        }
    }

    if(variant.featured_image.src && document.querySelector(".sticky_atc_main .variant_image_JS")){
        document.querySelector(".sticky_atc_main .variant_image_JS").setAttribute("src",variant.featured_image.src);
    }

  }
});

if(document.querySelector(".sticky_atc_main .atc_button_js")){
    document.querySelector(".sticky_atc_main .atc_button_js").addEventListener("click",function(){
        if(document.querySelector(".product .product-form .product-form__buttons .product-form__submit")){
            document.querySelector(".product .product-form .product-form__buttons .product-form__submit").click();

            document.querySelector(".sticky_atc_main .atc_button_js").classList.add("atc_run");
            document.querySelector(".sticky_atc_main .atc_button_js .loading__spinner").classList.remove("hidden");

            var myInterval = setInterval(function () {
                if(document.querySelector("cart-drawer.active")){
                    document.querySelector(".sticky_atc_main .atc_button_js").classList.remove("atc_run");
                    document.querySelector(".sticky_atc_main .atc_button_js .loading__spinner").classList.add("hidden");
                    clearInterval(myInterval);
                }
            }, 1000);
        }
    });
}

if(document.querySelector(".sticky_atc_main .checkout_JS")){
    document.querySelector(".sticky_atc_main .checkout_JS").addEventListener("click",function(){
        // Outside India: Shiprocket checkout is India-only — use the native
        // Shopify Buy Now on the PDP form (custom.js: add to cart → /checkout).
        if(document.body.getAttribute("data-diorin-country") !== "IN"){
            var intlBtn = document.querySelector(".product .product-form .diorin-intl-buynow");
            if(intlBtn){ intlBtn.click(); return; }
        }
        if(document.querySelector(".product .product-form .sr-headless-checkout")){
            document.querySelector(".product .product-form .sr-headless-checkout").click();
        }
        if(document.querySelector(".product .product-form #gokwik-buy-now")){
            document.querySelector(".product .product-form #gokwik-buy-now").click();
        }
    });
}

// Show sticky ATC only when user reaches the Description/Specification tabs
var stickyFormEl = document.querySelector('.product product-form.product-form');
var stickyMain   = document.querySelector('.sticky_atc_main');

if(stickyFormEl && stickyMain){
    function checkStickyATC() {
        // Buy button must be fully off-screen (scrolled past)
        var buyGone = stickyFormEl.getBoundingClientRect().bottom < 0;

        // Description/Specification accordion must be entering the viewport
        var accordionEl = document.querySelector('.product__accordion');
        var tabsVisible = accordionEl
            ? accordionEl.getBoundingClientRect().top < window.innerHeight
            : buyGone; // fallback: if no accordion found, use buy button logic

        if (buyGone && tabsVisible) {
            stickyMain.classList.add('active');
        } else {
            stickyMain.classList.remove('active');
        }
    }

    // Check on every scroll
    document.addEventListener('scroll', checkStickyATC, { passive: true });

    // Run immediately on load so initial state is always correct
    requestAnimationFrame(checkStickyATC);
}
